import { render, staticRenderFns } from "./IapHigh.vue?vue&type=template&id=5ff5ff4b&scoped=true"
import script from "./IapHigh.vue?vue&type=script&lang=js"
export * from "./IapHigh.vue?vue&type=script&lang=js"
import style0 from "./IapHigh.vue?vue&type=style&index=0&id=5ff5ff4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5ff4b",
  null
  
)

export default component.exports